__turbopack_context__.v({
  "cta": "featured-promos-module-scss-module__4cPH2W__cta",
  "eyebrow": "featured-promos-module-scss-module__4cPH2W__eyebrow",
  "imageWrapper": "featured-promos-module-scss-module__4cPH2W__imageWrapper",
  "info": "featured-promos-module-scss-module__4cPH2W__info",
  "infoContainer": "featured-promos-module-scss-module__4cPH2W__infoContainer",
  "promoCard": "featured-promos-module-scss-module__4cPH2W__promoCard",
  "title": "featured-promos-module-scss-module__4cPH2W__title",
});
